<template></template>

<script>
import { get, each, clone, isEmpty, has, toNumber, isEqual } from 'lodash';

export default {
  name: 'evolution-settings-form-input-abstract',
  props: {
    input: {
      required: true,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    percentageValueField: {
      type: Boolean,
      required: false,
      default: false,
    },
    allData: {
      type: Object,
      required: false,
      default: null,
    },
    originalData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      calculatedFromValues: {},
    };
  },
  methods: {
    update() {},
    getFormValue(from) {
      const formSimple = get(this.allData, `${from}.value`);
      const formText = get(this.allData, `${from}.value_text`);
      const formJSON = get(this.allData, `${from}.value_json`);
      const formValue = formSimple || formText || formJSON || null;
      return clone(formValue);
    },
    checkIsEqual(itemValue, originalValue) {
      let equal = true;
      if (itemValue && originalValue) {
        const itemValueNumber = toNumber(itemValue);
        const originalValueNumber = toNumber(originalValue);

        if (itemValueNumber && originalValueNumber) {
          if (!isEqual(itemValueNumber, originalValueNumber)) equal = false;
        } else if (itemValue !== originalValue) equal = false;
      }
      return equal;
    },
    calculatedFromChanged() {
      let changed = 0;
      if (!isEmpty(this.input.calculated_from)) {
        each(this.input.calculated_from, (from) => {
          each(from, (item) => {
            const itemValueJSON = get(this.allData, `${item}.value_json`, null);
            const originalValueJSON = get(this.originalData, `${item}.value_json`, null);

            if (itemValueJSON && originalValueJSON) {
              each(itemValueJSON, (value, key) => {
                const originalValue = get(originalValueJSON, key);
                if (!this.checkIsEqual(value, originalValue)) changed += 1;
              });
            } else {
              const itemValue = get(this.allData, `${item}.value`);
              const originalValue = get(this.originalData, `${item}.value`);

              if (!this.checkIsEqual(itemValue, originalValue)) changed += 1;
            }
          });
        });
      }
      return changed > 0;
    },
  },
  computed: {
    willBeCalculated() {
      const calculatedFromChanged = this.calculatedFromChanged();
      const showInput = this.input.overridable || has(this.input, 'Measurement.value') || has(this.input, 'Measurement.value_text');
      const willBeCalculated = showInput ? this.input.calculated && !this.setManually && !calculatedFromChanged : this.input.calculated && !this.setManually;
      // console.log('willBeCalculated', this.input.code, calculatedFromChanged, showInput, willBeCalculated);
      // willBeCalculated muscle_mass false true false
      return !showInput || willBeCalculated;
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/measurement/tracked-measurements-form-input-groups/form-input-types/cmpt-form-input-abstract.vue